<template>
  <div id="" class="log">
    <div class="log-nav">
      <el-form ref="formData" :rules="rules" :model="formData">
        <el-form-item style="width:16%;" prop="nodeid">
          <el-input placeholder="请输入NodeID" v-model.number="formData.nodeid"></el-input>
        </el-form-item>
        <el-form-item style="width:16%;">
          <el-input placeholder="请输入IP" v-model="formData.ip"></el-input>
        </el-form-item>
        <el-form-item style="width:16%;">
          <el-input placeholder="请输入线程名称" v-model="formData.threadName"></el-input>
        </el-form-item>
        <el-form-item style="width:16%;">
          <el-input placeholder="请输入日志级别" v-model="formData.level"></el-input>
        </el-form-item>
      </el-form>
      <el-form>
        <el-form-item style="width:16%;">
          <input type="text" id="test1" v-model="form.date1" placeholder="请输入开始时间" style="height: 40px;">
        </el-form-item>
        <el-form-item style="width:16%;">
          <input type="text" id="test2" v-model="form.date2" placeholder="请输入结束时间" style="height: 40px;">
        </el-form-item>
        <el-form-item style="width:16%;">
          <el-input placeholder="请输入关键字" v-model="formData.keyWord"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="log-info">
      <template>
        <el-table
          default-expand-all
          v-loading="sending"
          :data="tableData"
          style="width: 100%">
          <!-- <el-table-column type="expand" style="background:#F1F4FE;">
            <template slot-scope="props">
              <p style="float:left;width:6%;">日志信息：</p>
              <p style="float:left;width:94%">{{props.row.message}}</p>
            </template>
          </el-table-column> -->
          <el-table-column type="expand" style="background:#F1F4FE;">
            <template slot-scope="props">
              <p style="float:left;width:6%;">日志信息：</p>
              <p style="float:left;width:94%;" v-html="brightenKeyword(props.row.message,formData.keyWord)"></p>
            </template>
          </el-table-column>
          <el-table-column
            prop="nodeId"
            align="center"
            label="NodeID"
            width="80">
          </el-table-column>
          <!-- <el-table-column
            prop="node_type"
            align="center"
            label="NodeType"
            width="200">
          </el-table-column> -->
          <!-- <el-table-column
            prop="message"
            :show-overflow-tooltip="true"
            align="center"
            width="600px"
            label="日志信息">
            <template  slot-scope="scope">
              <div style="text-align:left;">
                {{scope.row.message}}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="loggerName"
            align="center"
            width="600"
            label="loggerName">
          </el-table-column>
          <el-table-column
            align="center"
            width="300"
            prop="threadName"
            label="线程名称">
            <template slot-scope="scope">
              <span v-html="brightenKeyword(scope.row.threadName,formData.threadName)" ></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="level"
            label="日志级别"
            align="center"
            width="200">
            <template slot-scope="scope">
              <span v-html="brightenKeyword(scope.row.level,formData.level)" ></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            align="center"
            width="180"
            label="日志时间" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop=""
            align="center"
            width="200"
            label="上下文按钮">
            <template slot-scope="scope">
              <span @click="seeLogThings(scope.row.threadPriority,scope.row.nodeId,scope.row.threadName,scope.row.eventid)" style="color:#1385F9;cursor:pointer;">查看</span>
            </template>
          </el-table-column>

        </el-table>
      </template>
    </div>
    <!-- <div class="block paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-size="page.pageSize"
        layout=" prev, next"
        prev-text="上一页"
        next-text="下一页">
      </el-pagination>
    </div> -->
    <div class="block paging">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[5, 10, 20, 30,50]"
        :page-size="page.pageSize"
        layout=" sizes, prev, pager, next, jumper"
        :total="page.totalSize"
        >
        </el-pagination>
    </div>
  </div>
</template>
<script type="text/javascript" src="iview.min.js"></script>
<script>
  export default {
    name: 'log',
    data() {
      var validateNodeid = (rule, value, callback) => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'));
        }else {
          callback();
        }
      };
      return {
        beforeTime:'',
        // 日期
        date: '',
        formData: {
          // IP
          ip: '',
          nodeid:'',//nodeId
          threadName:'',//threadName线程名称
          level:'',//level日志级别
          keyWord: '',// 关键字
        },
        currentPage: 4,
        sending:false,
        form:{
          date1:'',
          date2:'',
        },
        page:{
            pageSize:5,
            totalSize:0,
            pageNum:1
        },
        tableData: [],
        rules: {
          nodeid: [
             { validator: validateNodeid,  trigger: 'blur' },
          ]
        },
      }
    },
    mounted(){
      this.aa();
      // this.search();
      this.getList('1');
      var frontOneHour = new Date(new Date().getTime() - 1 * 60 * 60 * 1000);
      var hoursBefore = new Date(new Date().getTime() - 1 * 60 * 60 * 1000); // 前一个小时
      Date.prototype.format = function(fmt) {
       var o = {
            "M+" : this.getMonth()+1,                 //月份
            "d+" : this.getDate(),                    //日
            "h+" : this.getHours(),                   //小时
            "m+" : this.getMinutes(),                 //分
            "s+" : this.getSeconds(),                 //秒
            "q+" : Math.floor((this.getMonth()+3)/3), //季度
            "S"  : this.getMilliseconds()             //毫秒
        };
        if(/(y+)/.test(fmt)) {
                fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
        }
         for(var k in o) {
            if(new RegExp("("+ k +")").test(fmt)){
                 fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
             }
         }
        return fmt;
      }
      // this.form.date1 = new Date(new Date().getTime() - 1 * 60 * 60 * 1000).format("yyyy-MM-dd hh:mm:ss"); //前提一个小时
      // this.form.date2 = new Date().format("yyyy-MM-dd hh:mm:ss");//当前时间
      // var _this = this;
      // this.timer = setInterval(function(){
      //   _this.sending = true;
      //   let params = {
      //       pageNum:_this.page.pageNum,
      //       pageSize:_this.page.pageSize,
      //       begainTime:_this.form.date1,
      //       endTime:_this.form.date2,
      //       key:_this.keyWord,
      //       ip:_this.ip,
      //       nodeid:_this.nodeid,
      //       threadName:_this.threadName,
      //       level:_this.level,
      //       isFindContent:0,
      //       beforeTime:''
      //   };
      //   // params = Object.assign(params,this.form);
      //   params = _this.$qs.stringify(params,{ indices: false });
      //   _this.axios({
      //       method:'post',
      //       url:window.API_HOST+'/log/findLogsByKey',
      //       data:params,
      //       // timeout:1000 * 60 * 10
      //       timeout: 10000
      //   }).then((res)=>{
      //       _this.sending = false;
      //       if(res.data.list.length != 0){
      //         if(e == '1'){
      //           _this.beforeTime = res.data.list[0].date;
      //         }
      //         _this.tableData = res.data.list;
      //         console.log("data:"+_this.tableData.length);
      //         for(let i=0;i<this.tableData.length;i++){
      //           _this.tableData[i].threadPriority = _this.tableData[i].date;
      //           var date = new Date(_this.tableData[i].date);
      //           var Y = date.getFullYear() + '-';
      //           var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      //           var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
      //           var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
      //           var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
      //           var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
      //           // console.log(Y+M+D+h+m+s)
      //           _this.tableData[i].date =  Y+M+D+h+m+s;
      //         }
      //         _this.page = res.data.page;
      //       }else{
      //         _this.tableData = [];
      //         _this.$message({
      //           message: '暂无消息',
      //           type: 'warning'
      //         });
      //       }
      //   })
      //   .catch(error =>{
      //     // console.log(error);
      //     // alert("服务器超时未响应");
      //     _this.sending = false;
      //   })
      // },1000*60);
    },
    beforeDestroy:function(){
      if(this.timer){
        clearInterval(this.timer); //在Vue实例销毁前，清除我们的定时器
      }
    },
    destroyed:function() {
      this.socket.close();
    },
    methods: {
      aa(){
        console.log(laydate)
        laydate.render({
          elem: '#test1',
          type:'datetime',
          // theme: 'grid',
          theme: '#0090ff',
          done: (value) => {
            this.form.date1 = value;
          }
        });
        laydate.render({
          elem: '#test2',
          type:'datetime',
          // theme: 'grid',
          theme: '#0090ff',
          done: (value) => {
            this.form.date2 = value;
          }
        });
      },
      getList(e){
        this.sending = true;
        let params = {
            pageNum:this.page.pageNum,
            pageSize:this.page.pageSize,
            begainTime:this.form.date1,
            endTime:this.form.date2,
            key:this.formData.keyWord,
            ip:this.formData.ip,
            nodeid:this.formData.nodeid,
            threadName:this.formData.threadName,
            level:this.formData.level,
            isFindContent:0,
            beforeTime:this.beforeTime
        };
        // params = Object.assign(params,this.form);
        params = this.$qs.stringify(params,{ indices: false });
        var _this = this;
        this.axios({
            method:'post',
            url:window.API_HOST+'/log/findLogsByKey',
            data:params,
            // timeout:1000 * 60 * 10
            timeout: 10000
        }).then((res)=>{
            this.sending = false;
            if(res.data.list.length != 0){
              if(e == '1'){
                this.beforeTime = res.data.list[0].date;
              }
              this.tableData = res.data.list;
              console.log("data:"+this.tableData.length);
              for(let i=0;i<this.tableData.length;i++){
                this.tableData[i].threadPriority = this.tableData[i].date;
                var date = new Date(this.tableData[i].date);
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
                // console.log(Y+M+D+h+m+s)
                this.tableData[i].date =  Y+M+D+h+m+s;
              }
              this.page = res.data.page;
            }else{
              this.tableData = [];
              this.$message({
                message: '暂无消息',
                type: 'warning'
              });
            }
        })
        .catch(error =>{
          // console.log(error);
          // alert("服务器超时未响应");
          this.$message({
            message:'服务器响应超时',
            type:'warning',
          })
          this.tableData = [];
          this.sending = false;
        })
      },
      //查询上下文信息
      seeLogThings(date,nodeid,threadname,eventid){
        this.$router.push({
          path:'/logmessage',
          query:{
            dateT:date,
            nodeidT:nodeid,
            threadnameT:threadname,
            eventid:eventid
          }
        })
      },
      search(){
        this.beforeTime = '';
        this.page.pageNum = 1;
        var time1 = this.form.date1;
        var time2 = this.form.date2;
        var dateSpan,
            tempDate,
            sDate1,
            sDate2;
          sDate1 = Date.parse(time1);
          sDate2 = Date.parse(time2);
          dateSpan = sDate2 - sDate1;
          dateSpan = Math.abs(dateSpan);
          var iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
          var dayS = iDays + 1;
          // if(this.form.date1.length != 19 || this.form.date2.length != 19){
          //   this.$message.error("起止日期格式书写有误");
          //   return;
          // }
        this.getList('1');
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.page.pageSize = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.page.pageNum = val;
        console.log(`当前页: ${val}`);
        this.getList();
      },
      //关键词高亮显示
      brightenKeyword(val, keyword) {
        val = val + '';
        var str = ['SendType','FromID','ToID','OpCode'];
        for(var i= 0;i<str.length;i++){
          if(val.indexOf(str[i]) !== -1)
          val = val.replace(str[i], '<font color="red">' + str[i] + '</font>');
        }
        if (val.indexOf(keyword) !== -1 && keyword !== '') {
          return val.replace(keyword, '<font color="red">' + keyword + '</font>')
        } else {
          return val;
        }
        // console.log(val)
        // const Reg = new RegExp(keyword, 'i');
        //   if (val) {
        //       const res = val.replace(Reg, `<span style="color: #409EFF;">${keyword}</span>`);
        //       console.log(res);
        //       return res;
        //   }
    },


    },

  }
</script>
<style lang="scss">
  .log {
    padding: 20px;
    background: #ffffff;
    .log-flex {
      display: flex;
      align-items: center;
    }
    .el-table__expanded-cell{
      background: #F1F4FE;
    }
    .el-form {
      display: flex;
      width: 100%;
      .el-form-item{
        margin-right: 70px;
        .el-form-item__content{
          width: 100%;
        }
      }

    }
    .log-info {
      padding: 10px 0;
    }
    .paging {
      display: flex;
      justify-content: flex-end;
      padding: 20px;
    }
    .el-table__expand-icon{
      display: none;
    }
    .el-pagination{
      margin: 0 auto;
    }
  }
  #test1 , #test2{
        position: relative;
    font-size: 14px;
    display: inline-block;
    width: 100%;
    height: 104%;
    border-radius: -1%;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 17px;
  }
  input::-webkit-input-placeholder {
    color: #c0c4cc;
  }
  input::-moz-input-placeholder {
    color: #c0c4cc;
  }
  input::-ms-input-placeholder {
    color: #c0c4cc;
  }
</style>
